import React from "react";

import Signup from "../Signup";
import {
    PageTitle,
    PageSubtitle,
    PageWrapper,
    PageFormContent
} from "../styles";

import { afterSocialAuth } from "frontend/hooks/useAuth";
import { useSignupEmail } from "../helpers";

const SocialSignupConfirmationPage = () => {
    const { provider } = useSignupEmail({ isSocialSignup: true });

    const capitalizedProviderName =
        provider && provider[0].toUpperCase() + provider.substring(1);

    return (
        <PageWrapper darkMode>
            <PageTitle darkMode>One Last Step</PageTitle>
            <PageSubtitle>
                Make sure your information from {capitalizedProviderName} is
                correct.
            </PageSubtitle>
            <PageFormContent>
                <Signup isSocialSignup afterAuth={afterSocialAuth} />
            </PageFormContent>
        </PageWrapper>
    );
};

export default SocialSignupConfirmationPage;
